/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { LinkBanner as LinkBannerComp } from '@marriott/mi-ui-library';
import { StyledLinkBanner } from './LinkBanner.styles';

export const LinkBannerConfig = {
  emptyLabel: 'LinkBanner',
  isEmpty: () => true,
  resourceType: `mi-aem-common-spa/components/content/linkbanner`,
};

export const LinkBanner = (props: any): JSX.Element => {
  return (
    <StyledLinkBanner data-testid="luxury-LinkBanner" data-component-name="m-luxury-LinkBanner">
      <EditableComponent config={LinkBannerConfig} {...props} className="container lb__wrapper p-0">
        <LinkBannerComp {...props} mobToggle={true} headerToggle={false} />
      </EditableComponent>
    </StyledLinkBanner>
  );
};
